<div
  class="analytics-container"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'tablet'
        : 'mobile'
      : 'desktop'
  "
>
  <div class="no-data-container" *ngIf="!hasData">
    <img src="assets/images/analytics.svg" class="analytics-icon" />
    <h3>No data is available for the selected date range.</h3>
  </div>
  <div [hidden]="!hasData" class="chart-and-yoy-container">
    <div id="chart" class="chart-container"></div>

    <div
      class="yoy-badges-container"
      *ngIf="showYoyRow && chartDisplayData.length > 0"
    >
      <div class="yoy-grid" #yoyGrid>
        <div
          *ngFor="let item of chartDisplayData; let i = index"
          class="yoy-item"
        >
          <span
            *ngIf="item.yoyPercent !== null"
            class="yoy-badge"
            [ngClass]="item.yoyType"
          >
            <img
              [src]="
                item.yoyType === 'increase'
                  ? 'assets/icon/arrow-up-green.svg'
                  : item.yoyType === 'decrease'
                    ? 'assets/icon/arrow-down-red.svg'
                    : 'assets/icon/arrow-sides-gray.svg'
              "
              class="yoy-icon"
              alt="YoY trend"
            />
            {{ item.yoyPercent | number: '1.0-0' }}%
            <span class="yoy-suffix">(YoY)</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
